<template>
    <div class="app-body"
         id="view">
        <div class="padding">
            <div class="box">
                <div class="box-header">
                    <div class="row pl-3 pr-3">
                        <div class="col-xl-3 mb-2">
                            <h2>Add Account</h2>
                            <small>Here you can add a new user account.</small>
                        </div>
                        <div class="col-xl-9">
                            <router-link :to="{ name: 'Dashboard' }"
                                         tag="button"
                                         class="btn blue pull-right">
                                Back
                            </router-link>
                        </div>
                    </div>
                </div>
                <div class="padding"
                     v-if="!auth.user.profile.is_reseller">
                    <!-- ///////// Admin form /////////// -->
                    <el-form ref="addUserForm"
                             label-width="190px"
                             label-position="left"
                             :model="user"
                             :rules="rules"
                             v-loading="loading"
                             onsubmit="return false;">
                        <div class="row">
                            <div class="col-sm-6">
                                <el-form-item label="HubSpot Deal Id"
                                              prop="hubspot_deal_id">
                                    <el-input v-model="user.hubspot_deal_id"
                                              @input="findHubspotDeal">
                                    </el-input>
                                </el-form-item>
                                <el-form-item label="Account name"
                                              prop="company_name">
                                    <el-input v-model="user.company_name"
                                              @input="preValidateForm('addUerForm')">
                                    </el-input>
                                </el-form-item>
                                <el-form-item label="Plan"
                                              prop="plan_id"
                                              v-if="!auth.user.profile.is_reseller">
                                    <el-select v-model="user.plan_id"
                                               placeholder="Select Plan"
                                               class="w-full"
                                               filterable
                                               @change="onPlanChange">
                                        <el-option v-for="item in plans"
                                                   :key="item.id"
                                                   :label="item.name"
                                                   :value="item.id">
                                            <span>
                                                {{
                                                    item.name +
                                                    ' ($' + item.price + ')'
                                                }}
                                            </span>
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="First name"
                                              prop="first_name">
                                    <el-input v-model="user.first_name"
                                              @input="preValidateForm('addUerForm')">
                                    </el-input>
                                </el-form-item>
                                <el-form-item label="Last name"
                                              prop="last_name">
                                    <el-input v-model="user.last_name"
                                              @input="preValidateForm('addUerForm')">
                                    </el-input>
                                </el-form-item>
                                <el-form-item label="Email"
                                              prop="email">
                                    <el-input placeholder="joe@example.com"
                                              v-model="user.email"
                                              @input="preValidateForm('addUerForm')">
                                    </el-input>
                                </el-form-item>
                                <el-form-item label="Phone number"
                                              prop="phone_number">
                                    <el-input v-model="user.phone_number"
                                              @input="preValidateForm('addUerForm')">
                                    </el-input>
                                </el-form-item>
                                <el-form-item label="Country"
                                              prop="country"
                                              v-if="!auth.user.profile.is_reseller">
                                    <el-select v-model="user.country"
                                               placeholder="Select Country"
                                               class="w-full"
                                               filterable
                                               @change="preValidateForm('addUserForm')">
                                        <el-option v-for="country in countries"
                                                   :key="country.id"
                                                   :label="country.name"
                                                   :value="country.id">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="Timezone"
                                              prop="timezone"
                                              v-if="!auth.user.profile.is_reseller">
                                    <el-select v-model="user.timezone"
                                               placeholder="Select Timezone"
                                               class="w-full"
                                               filterable
                                               @change="preValidateForm('addUserForm')">
                                        <el-option v-for="timezone in timezones"
                                                   :key="timezone.value"
                                                   :label="timezone.name"
                                                   :value="timezone.value">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="Minimum license count"
                                              prop="min_user_seat">
                                    <el-input v-model="user.min_user_seat"
                                              type="number"
                                              :min="1"
                                              @input="preValidateForm('addUserForm')">
                                    </el-input>
                                </el-form-item>
                            </div>
                            <div class="col-sm-6">
                                <el-form-item label="Create Test Line?">
                                    <el-switch v-model="user.test_line_enabled"
                                               :active-color="active_color"
                                               @change="preValidateForm('addUserForm')">
                                    </el-switch>
                                </el-form-item>
                                <div class="alert alert-info" style="max-width: 230px;">
                                    <b>Note for sales:</b>
                                    When creating accounts, PowerDialer and Sequence features are ONLY available with the xPro plan.
                                    <br><br>
                                    Bulk SMS is NOT available to trial accounts without permission. Please contact SalesOps for more information.
                                </div>
                                <div>
                                    <p>
                                        <a class="text-bluish _600" href="https://docs.google.com/spreadsheets/d/1MwlT2D5kk4ZpcbALBYDdLpNDwzL7hxVkfmbtXTZ2dZY/edit#gid=1765594618" target="_blank">Click
                                            here</a> for the Deal Desk
                                        <br>
                                        <a class="text-bluish _600" href="https://aloware.com/pricing/" target="_blank">Click here</a> tor the Alo Pricing Page
                                    </p>
                                </div>
                            </div>
                            <div class="col-sm-12 mt-5">
                                <el-form-item>
                                    <el-button type="success"
                                               class="mr-2"
                                               @click="customValidateForm('addUserForm')">
                                        Create
                                    </el-button>
                                </el-form-item>
                            </div>
                        </div>
                    </el-form>
                </div>
                <div class="padding col-md-6"
                     v-if="auth.user.profile.is_reseller">
                    <!-- ///////// Reseller form /////////// -->
                    <el-form ref="resellerForm"
                             label-width="200px"
                             label-position="top"
                             :rules="rules_reseller"
                             :model="reseller_user">
                        <el-form-item label="Account name"
                                      prop="company_name">
                            <el-input placeholder="Account Name"
                                      v-model="reseller_user.company_name"
                                      @input="preValidateForm('resellerForm')">
                            </el-input>
                        </el-form-item>

                        <el-form-item label="Plan"
                                      prop="plan_id"
                                      v-if="isModgenius">
                            <modgenius-plan-selector v-model="reseller_user.plan_id"
                                                     @change="onResellerPlanChange">
                            </modgenius-plan-selector>
                            <a class="text-decoration-underline el-link el-link--primary mt-1"
                               href="https://alwr.io/GkGz3a"
                               target="_blank">
                                See More Details
                            </a>
                        </el-form-item>

                        <el-form-item label="Country"
                                      prop="country">
                            <el-select v-model="reseller_user.country"
                                       placeholder="Select Country"
                                       class="w-full"
                                       autocomplete="off"
                                       filterable
                                       @change="preValidateForm('resellerForm')">
                                <el-option label="United States" value="US"></el-option>
                                <el-option label="Canada" value="CA"></el-option>
                            </el-select>
                        </el-form-item>

                        <el-form-item label="Company Timezone"
                                      prop="timezone">
                            <el-select v-model="reseller_user.timezone"
                                       placeholder="Select Timezone"
                                       class="w-full"
                                       autocomplete="off"
                                       filterable
                                       @change="preValidateForm('resellerForm')">
                                <el-option
                                    v-for="item in timezone_options"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>

                        <el-form-item label="Admin's First Name"
                                      prop="first_name">
                            <el-input placeholder="First Name"
                                      v-model="reseller_user.first_name"
                                      @input="preValidateForm('resellerForm')">
                            </el-input>
                        </el-form-item>

                        <el-form-item label="Admin's Last Name"
                                      prop="last_name">
                            <el-input placeholder="Last Name"
                                      v-model="reseller_user.last_name"
                                      @input="preValidateForm('resellerForm')">
                            </el-input>
                        </el-form-item>

                        <el-form-item label="Admin's Email Address"
                                      prop="email">
                            <el-input placeholder="Email Address"
                                      v-model="reseller_user.email"
                                      @input="preValidateForm('resellerForm')">
                            </el-input>
                        </el-form-item>

                        <el-form-item label="Admin's Phone Number"
                                      prop="phone_number">
                            <el-input placeholder="Phone Number"
                                      v-model="reseller_user.phone_number"
                                      @input="preValidateForm('resellerForm')">
                            </el-input>
                        </el-form-item>

                        <el-form-item label="Minimum user seat"
                                      prop="min_user_seat"
                                      v-if="auth.user.profile.reseller.display_min_seat_count">
                            <el-input v-model="reseller_user.min_user_seat"
                                      type="number"
                                      :min="1"
                                      @input="preValidateForm('addUserForm')">
                            </el-input>
                        </el-form-item>

                        <el-form-item>
                            <el-button type="success"
                                       class="pull-right"
                                       :loading="loading"
                                       :disabled="!validated"
                                       @click="saveUser">
                                <i class="material-icons pull-left"
                                   v-show="!loading">add</i>
                                Create
                            </el-button>

                            <el-button class="pull-right mr-2"
                                       :loading="loading"
                                       @click="$emit('cancel')">
                                Cancel
                            </el-button>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import auth from '../../auth'
import ModgeniusPlanSelector from '../../components/modgenius/modgenius-plan-selector.vue'
import {mapState} from 'vuex'
import {acl_mixin, form_validation_mixin, validator_mixin} from '../../mixins'
import debounce from "lodash/debounce"
import { PRE_SIGNUP_SUBMISSION_TYPES } from '../../constants/pre-signup'
import {STARTUP_PACKAGES} from "../../../user/constants/startup_packages";

const _default_user = () => {
    return {
        company_name: '',
        first_name: '',
        last_name: '',
        phone_number: '',
        email: '',
        carrier: 'twilio',
        enabled: true,
        timezone: null,
        international_enabled: false,
        auto_dialer_enabled: false,
        automation_enabled: false,
        bulk_sms_enabled: false,
        bulk_rvm_enabled: false,
        test_line_enabled: false,
        crm_integrations_enabled: true,
        account_name: '',
        account_sid: '',
        account_token: '',
        country: 'US',
        plan_id: null,
        international_tier: 1,
        min_user_seat: 1,
        hubspot_deal_id: null,
        hubspot_company_id: null,
        submission_type: PRE_SIGNUP_SUBMISSION_TYPES.admin.id
    }
}

export default {
    props: {
        active_color: {
            type: String,
            default: '#00a344'
        }
    },

    mixins: [
        acl_mixin,
        validator_mixin,
        form_validation_mixin
    ],

    components: {
        ModgeniusPlanSelector
    },

    data() {
        var validatePhone = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('Please provide a phone number'))
            } else {
                if (this.validatePhone(value)) {
                    callback()
                } else {
                    callback(new Error('Phone number is not valid'))
                }
            }
        }

        var userMinSeatValidator = (rule, value, callback) => {
            // Validation applies only for Super Admins and ModGenius partner
            if ((this.auth?.user?.profile?.is_reseller && this.auth?.user?.profile?.reseller?.display_min_seat_count) || this.auth?.user?.profile?.is_super_admin) {
                if (value < 1) {
                    callback(new Error('Please provide a valid number of minimum user seat (greater or equal to 1)'))
                    return
                } else {
                  const planId = this.auth?.user?.profile?.is_reseller ? this.reseller_user?.plan_id : this.user?.plan_id
                  const plan = this.plans.find(plan => plan.id === planId)
                    if (plan && STARTUP_PACKAGES.includes(plan.name) && value > 1) {
                      callback(new Error('Maximum allowed value for the Startup package is 1'))
                      return
                    }
                    callback()
                }
            } else {
                callback()
            }
        }

        return {
            auth: auth,
            plans: [],
            countries: [],
            user: _default_user(),
            reseller_user: {
                company_name: null,
                first_name: null,
                last_name: null,
                phone_number: null,
                email: null,
                timezone: null,
                country: null,
                suppress_emails: false,
                plan_id: null,
                min_user_seat: 1,
                submission_type: PRE_SIGNUP_SUBMISSION_TYPES.reseller.id
            },
            rules: {
                company_name: [
                    {
                        required: true,
                        message: 'Please provide an account name',
                        trigger: 'blur'
                    },
                ],
                country: [
                    {
                        required: true,
                        message: 'Please select a country',
                        trigger: 'blur'
                    },
                ],
                plan_id: [
                    {
                        required: true,
                        message: 'Please select a plan',
                        trigger: 'blur'
                    }
                ],
                first_name: [
                    {
                        required: true,
                        message: 'Please provide a first name',
                        trigger: 'blur'
                    },
                ],
                last_name: [
                    {
                        required: true,
                        message: 'Please provide a last name',
                        trigger: 'blur'
                    },
                ],
                timezone: [
                    {
                        required: true,
                        message: 'Please select a timezone',
                        trigger: 'blur'
                    },
                ],
                email: [
                    {
                        required: true,
                        message: 'Please provide email address',
                        trigger: 'blur'
                    },
                    {
                        type: 'email',
                        message: 'Please provide correct email address',
                        trigger: 'blur'
                    }
                ],
                phone_number: [
                    {
                        required: true,
                        message: 'Please provide a phone number',
                        trigger: 'blur'
                    },
                    {
                        validator: validatePhone,
                        trigger: 'blur'
                    },
                ],
                account_name: [
                    {
                        required: true,
                        message: 'Please provide a voip account name',
                        trigger: 'blur'
                    },
                ],
                account_sid: [
                    {
                        required: true,
                        message: 'Please provide a voip account sid',
                        trigger: 'blur'
                    },
                ],
                account_token: [
                    {
                        required: true,
                        message: 'Please provide a voip account token',
                        trigger: 'blur'
                    },
                ],
                hubspot_deal_id: [
                    {
                        required: this.env === 'production' && !this.auth?.user?.profile?.is_super_admin, // required field for non super admin in production
                        message: 'Please provide a HubSpot Deal ID. Only a Super Admin can leave this field blank.',
                        trigger: 'blur'
                    },
                ],
                min_user_seat: [
                    {
                        validator: userMinSeatValidator,
                        trigger: 'change'
                    },
                ],
            },
            rules_reseller: {
                company_name: [
                    {
                        required: true,
                        message: 'Please provide an account name',
                        trigger: 'blur'
                    },
                ],
                country: [
                    {
                        required: true,
                        message: 'Please select a country',
                        trigger: 'blur'
                    },
                ],
                first_name: [
                    {
                        validator: this.firstNameRequiredValidator,
                        trigger: 'blur'
                    },
                ],
                last_name: [
                    {
                        validator: this.lastNameRequiredValidator,
                        trigger: 'blur'
                    },
                ],
                timezone: [
                    {
                        required: true,
                        message: 'Please select a timezone',
                        trigger: 'blur'
                    },
                ],
                email: [
                    {
                        required: true,
                        message: 'Please provide an email address',
                        trigger: 'blur'
                    },
                    {
                        type: 'email',
                        message: 'Please provide a correct email address',
                        trigger: 'blur'
                    }
                ],
                phone_number: [
                    {
                        required: true,
                        message: 'Please provide a phone number',
                        trigger: 'blur'
                    },
                    {
                        validator: this.phoneValidator,
                        trigger: 'blur'
                    },
                ],
                min_user_seat: [
                    {
                        validator: userMinSeatValidator,
                        message: 'Please provide a valid number of minimum user seat (greater or equal to 1)',
                        trigger: 'change'
                    },
                ],
            },
            timezone_options: [
                {
                    label: 'New York (Eastern)',
                    value: 'America/New_York'
                },
                {
                    label: 'Chicago (Central Standard Time)',
                    value: 'America/Chicago'
                },
                {
                    label: 'Denver (Mountain Daylight Time)',
                    value: 'America/Denver'
                },
                {
                    label: 'Phoenix (Mountain Standard Time)',
                    value: 'America/Phoenix'
                },
                {
                    label: 'Los Angeles (Pacific Standard Time)',
                    value: 'America/Los_Angeles'
                },
                {
                    label: 'Honolulu (Hawaii Standard Time)',
                    value: 'Pacific/Honolulu'
                }
            ],
            loading: false
        }
    },

    computed: {
        ...mapState(['env']),

        timezones() {
            if (this.user.country) {
                if (this.user.country != 'US') {
                    return window.countriesAndTimezones.getTimezonesForCountry(this.user.country)
                        .map((timezone) => {
                            return {
                                name: timezone.name + ' GMT ' + timezone.utcOffsetStr,
                                value: timezone.name
                            }
                        })
                }

                if (this.user.country == 'US') {
                    return [
                        {
                            value: 'America/New_York',
                            name: 'New York (Eastern)',
                        },
                        {
                            value: 'America/Chicago',
                            name: 'Chicago (Central Standard Time)',
                        },
                        {
                            value: 'America/Denver',
                            name: 'Denver (Mountain Daylight Time)',
                        },
                        {
                            value: 'America/Phoenix',
                            name: 'Phoenix (Mountain Standard Time)',
                        },
                        {
                            value: 'America/Los_Angeles',
                            name: 'Los Angeles (Pacific Standard Time)',
                        },
                        {
                            value: 'Pacific/Honolulu',
                            name: 'Honolulu (Hawaii Standard Time)',
                        },
                    ]
                }
            }

            return []
        },

        canGoBack() {
            return window.history.length > 1
        }
    },

    created() {
        this.getCountries()
        this.getFormOptions().then(res => {
            this.loading = false
        })
    },

    mounted() {
        VueEvent.fire('pageChanged', 'Add Account')

        if (auth.user.profile.is_reseller) {
            this.setResellerAdminFormRequiredFields()
        }
    },

    methods: {
        setResellerAdminFormRequiredFields() {
            for (let rule in this.rules) {
                switch (rule) {
                    case 'company_name':
                    case 'first_name':
                    case 'last_name':
                    case 'phone_number':
                    case 'email':
                        this.rules[rule][0].required = true
                        break;
                    default:
                        this.rules[rule][0].required = false
                }
            }
        },

        getCountries() {
            const countries = window.countriesAndTimezones.getAllCountries()
            const countriesArr = Object.keys(countries).map((key) => {
                return countries[key]
            })

            let mappedCountries = countriesArr.map((country) => {
                if (!['US', 'CA'].includes(country.id)) {
                    return {
                        id: country.id,
                        name: country.name
                    }
                }
            }).filter((country) => country !== undefined)

            mappedCountries.unshift({
                id: 'CA',
                name: 'Canada'
            })

            mappedCountries.unshift({
                id: 'US',
                name: 'United States'
            })

            this.countries = mappedCountries
        },

        getFormOptions() {
            this.loading = true

            return Promise.all([
                axios.get('/api/admin/plan')
                    .then(res => {
                        this.plans = res.data

                        return Promise.resolve(res)
                    })
                    .catch(err => {
                        this.loading = false
                        return Promise.reject(err)
                    })
            ])
        },

        capitalizeFirstLetter: function (string) {
            return string.charAt(0).toUpperCase() + string.slice(1)
        },

        customValidateForm: function (form = 'addUserForm') {
            if (form === 'addUserForm') {
                this.$refs[form].validate((valid) => {
                    if (valid) {
                        this.saveUser()
                    }
                })
                return
            }

            this.validateForm(form)
        },

        validatePhone(phoneNumber) {
            return this.$options.filters.fixPhone(phoneNumber)
        },

        saveUser() {
            const success_notification_title = "Invite Sent to User"
            const success_notification_massage = "The user will need to verify their email to continue the process, then the account will be created."

            this.loading = true

            const is_reseller_user = this.auth.user.profile.is_reseller
            const request_params = {
                user: is_reseller_user ? this.reseller_user : this.user,
                pre_signup_endpoint: is_reseller_user ? '/api/admin/pre-signup-reseller' : '/api/admin/pre-signup-admin',
                reset_user_method: is_reseller_user ? this.resetResellerUser : this.resetUser,
            }

            // Send new PreSignup request
            axios.post(request_params.pre_signup_endpoint, request_params.user).then(res => {
                // reset user form data
                request_params.reset_user_method()

                // Redirect to dashboard
                this.$router.push({
                    name: 'Dashboard',
                })

                // Show success notification
                this.$notify({
                    offset: 95,
                    title: success_notification_title,
                    message: success_notification_massage,
                    type: 'success',
                    showClose: true,
                    duration: 5000,
                })

                this.loading = false

            }).catch(err => {
                this.$root.handleErrors(err.response)
                this.loading = false
            })
        },

        resetUser() {
            this.user = _default_user()
        },

        resetResellerUser() {
            this.reseller_user = {
                company_name: null,
                first_name: null,
                last_name: null,
                phone_number: null,
                email: null,
                timezone: null,
                country: null,
                suppress_emails: false,
                plan_id: null,
                min_user_seat: 1,
                submission_type: PRE_SIGNUP_SUBMISSION_TYPES.reseller.id,
            }
        },

        findHubspotDeal: debounce(function () {
            // empty input field and non-numeric id input
            if (this.user.hubspot_deal_id.length < 1 || !+this.user.hubspot_deal_id) {
                return
            }

            // find hubspot deal details
            axios.get(`/api/admin/company/find-hubspot-deal/${this.user.hubspot_deal_id}`)
                .then(res => {
                    // pre-populate fields
                    this.user.company_name = res.data?.hs_company_name
                    this.user.first_name = res.data?.hs_contact_first_name
                    this.user.last_name = res.data?.hs_contact_last_name
                    this.user.email = res.data?.hs_contact_email
                    this.user.phone_number = res.data?.hs_phone_number
                    this.user.hubspot_company_id = res.data?.latest_company_id
                    this.preValidateForm('addUserForm')
                })
                .catch(err => {
                    this.$root.handleErrors(err.response)
                })
        }, 1000),

        goBack() {
            if (this.canGoBack) {
                this.$router.go(-1)
            } else {
                this.$router.push({name: 'Dashboard'})
            }
        },

        onPlanChange(planId) {
            const plan = this.plans.find(plan => plan.id === planId);
            if (plan && STARTUP_PACKAGES.includes(plan.name)) {
                this.user.min_user_seat = 1;
            }

            this.preValidateForm('addUserForm');
        },

        onResellerPlanChange(planId) {
            const plan = this.plans.find(plan => plan.id === planId);
            if (plan && STARTUP_PACKAGES.includes(plan.name)) {
                this.reseller_user.min_user_seat = 1;
            }

            this.preValidateForm('resellerForm');
        }
    },

    beforeRouteEnter(to, from, next) {
        auth.check()
            .then((res) => {
                next()
            })
            .catch((err) => {
                next({name: 'Login', query: {redirect: to.fullPath}})
            })
    }
}
</script>
